import {createStore} from 'vuex'
import axios from "axios";
import moment from 'moment';

const api_url = process.env.VUE_APP_ROOT_API;

export default createStore({
    state: {
        account_info: {
            entries: []
        },
        current_acc: null,
        current_acc_obj: null,
        current_user: null,
        current_group: null,
        current_editor: "USER",
        remote: null,
        credentials: {},
        acc_list: {},
        user_list: {},
        group_list: {groups: []},
        messages: [],
        reports: [{
            last_modified: '2019-11-16 10:44:12',
            filename: "test.odt"
        }]
    },
    mutations: {
        switch_account(state, acc) {
            state.current_acc = acc;
            /*state.acc_list.accounts.forEach(acc_obj => {
              if (acc_obj.name == acc) {
                commit("switch_account_obj", acc_obj);
              }
            });*/
        },
        switch_account_obj(state, acc_obj) {
            state.current_acc_obj = acc_obj;
        },
        switch_user(state, user) {
            state.current_user = user;
        },
        switch_group(state, group) {
            state.current_group = group;
        },
        switch_editor(state, editor) {
            // eslint-disable-next-line
            console.log("Switching to editor: " + editor);
            state.current_editor = editor;
            // eslint-disable-next-line
            console.log("Switched to editor: " + state.current_editor);
        },
        update_remote(state, remote) {
            state.remote = remote;
        },
        update_acc_info(state, info) {
            console.log("Updating account info");
            console.log(info);
            state.account_info = Object.freeze(info);
        },
        update_acc_list(state, acc_list) {
            state.acc_list = acc_list;
        },
        update_user_list(state, user_list) {
            state.user_list = user_list;
        },
        update_group_list(state, group_list) {
            state.group_list = group_list;
        },
        update_acc_reports(state, reports) {
            state.reports = reports;
        },
        update_credentials(state, credentials) {
            localStorage.removeItem("credentials");
            localStorage.setItem("credentials", JSON.stringify(credentials));
            state.credentials = credentials;
        },
        remove_message(state, index) {
            state.messages.splice(index, 1);
        },
        add_message(state, msg) {
            state.messages.push(msg)
        }
    },
    actions: {
        switchAccountObj({commit, state}, acc_obj) {
            commit("switch_account", acc_obj.name);
            commit('switch_account_obj', acc_obj);
        },
        switchAccount({commit, state}, acc) {
            commit("switch_account", acc);
            console.log("Switch account action triggered: " + acc);
            for (const acc_obj of state.acc_list.accounts) {
                if (acc_obj.name === acc) {
                    console.log("Switching to account: " + acc);
                    commit('switch_account_obj', acc_obj);
                    break;
                }
                let accFound = false;
                if (acc_obj.accounts) {
                    for (const sub_acc_obj of acc_obj.accounts) {
                        if (sub_acc_obj.name === acc) {
                            console.log("Switching to sub-account: " + acc);
                            commit('switch_account_obj', sub_acc_obj);
                            accFound = true;
                            break;
                        }
                    }
                }
                if (accFound) {
                    break;
                }
            }
        },
        loadCurrentAccount({commit, state, dispatch}) {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            if (!credentials) {
                dispatch("logout")
                return
            }
            axios({
                url: api_url + "/account/" + state.current_acc + "/entries",
                method: "get",
                auth: credentials
            })
                .then(response => {
                    commit("update_acc_info", response.data);
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                    dispatch("logout")
                });
        },
        loadAccounts({commit, state, dispatch}) {
            let credentials = JSON.parse(localStorage.getItem('credentials'));
            if (!credentials) {
                dispatch("logout");
                return;
            }
            console.log("Load accounts");
            axios({
                url: api_url + "/accounts",
                method: "get",
                auth: credentials
            }).then(response => {
                commit("update_acc_list", response.data);
                if (state.current_acc === null) {
                    return;
                }
                for (const acc_obj of state.acc_list.accounts) {
                    if (acc_obj.id === state.current_acc_obj.id) {
                        commit('switch_account_obj', acc_obj);
                        break;
                    }
                    if (!acc_obj.accounts) {
                        continue;
                    }
                    let accFound = false;
                    for (const sub_acc_obj of acc_obj.accounts) {
                        if (sub_acc_obj.id === state.current_acc_obj.id) {
                            commit('switch_account_obj', sub_acc_obj);
                            accFound = true;
                            break;
                        }
                    }
                    if (accFound) {
                        break;
                    }
                }
            }).catch(e => {
                // eslint-disable-next-line
                console.log(e);
                dispatch("logout")
            });
        },
        loadData({commit, state, dispatch}) {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            if (!credentials) {
                dispatch("logout")
                return
            }
            // eslint-disable-next-line
            console.log("Load entries");
            axios({
                url: api_url + "/account/" + state.current_acc + "/entries",
                method: "get",
                auth: credentials
            })
                .then(response => {
                    commit("update_acc_info", response.data);
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                    //dispatch("logout")
                });
            dispatch("loadAccounts");
            console.log("Load remote");
            axios({url: api_url, auth: credentials, method: 'get'})
                .then(response => {
                    commit("update_remote", response.data)
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                })
            // eslint-disable-next-line
            console.log("Dispatching loadReports...");
            dispatch("loadReports");

        },
        loadUserData({commit, state}) {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            // eslint-disable-next-line
            console.log("axios users");
            axios({
                url: api_url + "/users",
                method: "get",
                auth: credentials
            })
                .then(response => {
                    // eslint-disable-next-line
                    console.log("Updating users");
                    commit("update_user_list", response.data);
                    // eslint-disable-next-line
                    console.log(response.data);
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                });
        },
        loadGroupData({commit, state}) {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            // eslint-disable-next-line
            console.log("axios groups");
            axios({
                url: api_url + "/groups",
                method: "get",
                auth: credentials
            })
                .then(response => {
                    // eslint-disable-next-line
                    console.log("Updating groups");
                    commit("update_group_list", response.data);
                    if (state.current_group === null) {
                        return;
                    }
                    for (const group of state.group_list.groups) {
                        if (group.id === state.current_group.id) {
                            commit('switch_group', group);
                            break;
                        }
                    }
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                });
        },
        loadReports({commit, state}) {
            if (state.current_acc === null) {
                // eslint-disable-next-line
                console.log("Account null, don't load reports...");
                return;
            }
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            // eslint-disable-next-line
            console.log("axios reports");
            axios({
                url: api_url + "/reports/" + state.current_acc,
                method: "get",
                auth: credentials
            })
                .then(response => {
                    // eslint-disable-next-line
                    console.log("Updating reports");
                    commit("update_acc_reports", response.data);
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                });
        },
        login({commit}, credentials) {
            return new Promise((resolve, reject) => {
                // The Promise used for router redirect in login
                axios({url: api_url, auth: credentials, method: "get"})
                    .then(resp => {
                        //const token = resp.data.token
                        //localStorage.setItem('user-token', token) // store the token in localstorage
                        var newCredentials = {
                            username: credentials.username,
                            password: resp.data.sessionKey
                        }
                        commit("update_credentials", newCredentials);
                        // you have your token, now log in your user :)
                        //dispatch(USER_REQUEST)
                        commit("update_remote", resp.data)
                        resolve(resp);
                    })
                    .catch(err => {
                        commit("update_credentials", {});
                        reject(err);
                    });
            });
        },
        logout({commit}) {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: api_url + "/logout",
                method: "get",
                auth: credentials
            })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                });
            commit("update_credentials", {});
            window.location.href = "/login";
        }
    }
});